import { useExperience } from '@cascade/react/experiences';
import { useI18n } from '@cascade/react/i18n';
import { Card, Icon, Text } from '@cascade/ui-library';
import classes from './ExperienceFailed.module.scss';
import { FailureActions } from '#components/failure-actions/index.ts';
import { Page } from '#components/page/index.ts';

export const ExperienceFailed = () => {
  const { translate, translateError } = useI18n();
  const { experienceError, reloadExperience } = useExperience();

  const message = experienceError
    ? translateError(experienceError)
    : translate('experience.failed.noSteps');

  return (
    <Page>
      <Card
        className={classes['experience-failed']}
        padding='xl'
        borderRadius='xl'
      >
        <div className={classes.body}>
          <Icon type='triangle-exclamation' color='text-warning' size='3xl' />
          <Text
            type='h3'
            weight='semibold'
            content={translate('experience.failed.title')}
            compact
          />
          <Text type='body-2' color='text-60' role='alert' content={message} />
          <FailureActions error={experienceError} onRetry={reloadExperience} />
        </div>
      </Card>
    </Page>
  );
};
